import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { CandidateService } from "../../../../modules/recruitment/candidates/candidate.service";

@Component({
  selector: "app-widget-last-candidate",
  templateUrl: "./widget-last-candidate.component.html",
  styleUrls: ["./widget-last-candidate.component.scss"],
})
export class WidgetLastCandidateComponent implements OnInit {
  public candidateList: any = [];
  public skills: any = [];

  constructor(
    public _utilsService: UtilsService,
    public _candidateService: CandidateService,
  ) {}

  async ngOnInit() {
    this.candidateList = await this._candidateService.getCandidatesList();
    this.candidateList = this.candidateList.sort((a: any, b: any) => b.insert_date - a.insert_date);
    this.candidateList = this.candidateList.slice(0, 5);
    this.candidateList = this.candidateList.map((item: any) => {
      item.skills = item.skills.filter((skill: any) => {
        return skill.primary == 1;
      });
      return item;
    });
  }
}
